/**
 * https://devdactic.com/custom-ionic-module-npm/
 */
export * from './components/accordion';
export * from './directives/autosize';
export * from './pipes/capitalize';
export * from './pipes/day-of-week';
export * from './pipes/search';
export * from './softwaredata.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/index.js
// module id = 858
// module chunks = 0